import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { CONTACT_INFO, SHIPPING_TIME } from '../data/mock';
import { CheckCircle, Package, Mail, Phone, ArrowRight } from 'lucide-react';

const OrderConfirmationPage = () => {
  const orderNumber = `CCG-${Date.now().toString().slice(-8)}`;

  useEffect(() => {
    document.title = 'Order Confirmed | Desk Line Supply';
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <main className="py-20">
        <div className="max-w-2xl mx-auto px-4 text-center">
          <div className="w-24 h-24 bg-athletic-500 rounded-2xl flex items-center justify-center mx-auto mb-8 shadow-button">
            <CheckCircle className="w-12 h-12 text-white" />
          </div>

          <h1 className="font-display text-3xl md:text-4xl text-dark-900 font-bold tracking-tight mb-4">
            Thank You for Your Order!
          </h1>

          <p className="text-dark-600 text-lg mb-8">
            Your order has been placed successfully. We&apos;ve sent a confirmation email with your order details.
          </p>

          <div className="bg-dark-50 p-6 rounded-2xl border border-dark-100 mb-8">
            <p className="text-dark-500 text-sm mb-2">Order Number</p>
            <p className="font-display text-2xl text-athletic-600 font-bold">{orderNumber}</p>
          </div>

          <div className="bg-dark-50 p-8 rounded-2xl border border-dark-100 mb-8 text-left">
            <h3 className="font-display font-bold text-dark-900 mb-4 flex items-center gap-2">
              <div className="w-8 h-8 bg-athletic-500 rounded-lg flex items-center justify-center">
                <Package className="w-4 h-4 text-white" />
              </div>
              What&apos;s Next?
            </h3>
            <ul className="space-y-4">
              {[
                "You'll receive an email confirmation shortly.",
                "We'll send you tracking information once your order ships.",
                `Expected delivery: ${SHIPPING_TIME}.`,
              ].map((text, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="w-7 h-7 bg-athletic-500 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0">{i + 1}</span>
                  <span className="text-dark-600">{text}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-dark-50 p-6 rounded-2xl border border-dark-100 mb-8">
            <h3 className="font-display font-bold text-dark-900 mb-4">Need Help?</h3>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
              <a href={`tel:${CONTACT_INFO.phone.replace(/[^0-9]/g, '')}`} className="flex items-center gap-2 text-athletic-600 hover:text-athletic-700 transition-colors font-medium">
                <Phone className="w-5 h-5" /> {CONTACT_INFO.phone}
              </a>
              <a href={`mailto:${CONTACT_INFO.email}`} className="flex items-center gap-2 text-athletic-600 hover:text-athletic-700 transition-colors font-medium">
                <Mail className="w-5 h-5" /> {CONTACT_INFO.email}
              </a>
            </div>
          </div>

          <Link to="/shop" className="inline-flex items-center gap-2 px-8 py-4 bg-athletic-500 hover:opacity-90 text-white font-bold uppercase tracking-wider rounded-lg transition-all shadow-button">
            Continue Shopping <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default OrderConfirmationPage;
